import styled from "styled-components";

export const Container = styled.div`
  max-width: 1040px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Container2 = styled.div`
  width: 100%;
  margin: 30px 0 180px 0;

  display: flex;
  flex-direction: column;

  align-items: center;
`;

export const DashedLine = styled.hr`
  width: 100%;
  margin: 0 auto;
  margin-bottom: 30px;

  background: #fff;
  border: none;
  border-top: 2px dashed #707070;
`;
